module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/correct@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/correct@3x.png
// module id = 709
// module chunks = 0